import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TextField, Paper } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import variables from 'src/style/variable/variables.module.scss';
import { useTranslation } from 'src/i18n';
import { pairUp } from '../Commissioning/utils';

const CONTROLLER_INFO_FIELDS = [
  'projectNo', 'area',
  'controllerNo', 'distributionPanel',
];


export default function ControllerInfo (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();
  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);

  const [controllerInfo, setControllerInfo] = useState(Map(data?.get('controllerInfo') || {}));

  useEffect(() => {
    setControllerInfo(Map(data?.get('controllerInfo') || {}));
  }, [data]);

  const onFieldChange = (key, val) => {
    const updated = controllerInfo.set(key, val);
    setControllerInfo(updated);
    onChange(['extras', 'controllerInfo', key], val);
  };

  const infoPairs = pairUp(CONTROLLER_INFO_FIELDS);

  return (
    <div>
      <Paper sx={{ marginBottom: '30px' }}>
        <h3>{t('commissioningController.reportTitle')}</h3>
        <TableContainer className={`default-control-panel-table${isMobile ? ' mobile-table' : ''}`}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className='sub-headers'>{t('common.field')}</TableCell>
                <TableCell className='sub-headers'>{t('common.value')}</TableCell>
                <TableCell className='sub-headers'>{t('common.field')}</TableCell>
                <TableCell className='sub-headers'>{t('common.value')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {infoPairs.map(([fieldA, fieldB]) => (
                <TableRow key={fieldA}>
                  <TableCell className='sub-headers'>{t(`commissioningController.table.${fieldA}`)}</TableCell>
                  <TableCell className='body-cell'>
                    <TextField
                      fullWidth
                      disabled={readOnly}
                      value={controllerInfo.get(fieldA) || ''}
                      onChange={(e) => onFieldChange(fieldA, e.target.value)}
                    />
                  </TableCell>
                  {fieldB ? (
                    <>
                      <TableCell className='sub-headers'>{t(`commissioningController.table.${fieldB}`)}</TableCell>
                      <TableCell className='body-cell'>
                        <TextField
                          fullWidth
                          disabled={readOnly}
                          value={controllerInfo.get(fieldB) || ''}
                          onChange={(e) => onFieldChange(fieldB, e.target.value)}
                        />
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell />
                      <TableCell />
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

ControllerInfo.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

ControllerInfo.defaultProps = {
  readOnly: false,
};
